import { Sparkles } from 'lucide-react'
import { toast } from 'sonner'

import { useState } from 'react'

import { AssistantModel, assistantError } from '@/http/models/assistant/Assistant'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'

import { assistantText } from './assistantText'
import { useAssistant } from './AssistantProvider'

interface GenerateTextButtonProps {
  field: 'description' | 'summary'
  title: string
  current?: string
  onText: (text: string) => void
}

/** "Generate text" beside a product text field: writes or improves it from the title, in the assistant's language. */
export const GenerateTextButton = ({ field, title, current, onText }: GenerateTextButtonProps) => {
  const { language, capabilities } = useAssistant()
  const t = assistantText(language)
  const [busy, setBusy] = useState(false)
  if (!capabilities?.enabled) return null

  const generate = async () => {
    if (title.trim().length < 2) {
      toast.info(t.needTitle)
      return
    }
    setBusy(true)
    const res = await AssistantModel.writeProductText({ field, title: title.trim(), current: current?.trim() || undefined, language })
    setBusy(false)
    if (res.success && res.data?.result.text) onText(res.data.result.text)
    else toast.error(assistantError(res.error, t.errorGeneric))
  }

  return (
    <Button type="button" variant="ghost" size="sm" onClick={generate} disabled={busy} className="gap-1 text-violet-dark">
      {busy ? <Spinner className="size-3.5" /> : <Sparkles />}
      {busy ? t.generating : t.generateText}
    </Button>
  )
}
